import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './TaskCard.css';

const TaskCard = ({ task }) => {
  const { currentUser } = useAuth();
  const isCreator = currentUser && task.createdBy._id === currentUser.id;
  
  // Formatear fecha
  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('es-ES', options);
  };
  
  return (
    <div className="card task-card h-100">
      {task.images && task.images.length > 0 && (
        <img 
          src={task.images[0]} 
          className="card-img-top task-card-image" 
          alt={task.title} 
        />
      )}
      
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-start mb-2">
          <span className="badge bg-primary">{task.category}</span>
          <span className="task-tokens">{task.tokens} <span className="token-blue">BLUE</span></span>
        </div>
        
        <h5 className="card-title">{task.title}</h5>
        <p className="card-text task-description">{task.description.substring(0, 100)}...</p>
        
        <div className="task-location mb-2">
          <i className="fas fa-map-marker-alt me-1"></i> {task.location}
        </div>
        
        <div className="task-date text-muted small mb-3">
          <i className="far fa-calendar-alt me-1"></i> {formatDate(task.createdAt)}
        </div>
      </div>
      
      <div className="card-footer bg-transparent">
        <Link to={`/tasks/${task._id}`} className="btn btn-outline-primary w-100">
          Ver Detalles
        </Link>
      </div>
    </div>
  );
};

export default TaskCard;
